/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.server.createSession'

export { $nsid }

/** Create an authentication session. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    identifier: l.string(),
    password: l.string(),
    authFactorToken: l.optional(l.string()),
    allowTakendown: l.optional(l.boolean()),
  }),
  l.jsonPayload({
    accessJwt: l.string(),
    refreshJwt: l.string(),
    handle: l.string({ format: 'handle' }),
    did: l.string({ format: 'did' }),
    didDoc: l.optional(l.lexMap()),
    email: l.optional(l.string()),
    emailConfirmed: l.optional(l.boolean()),
    emailAuthFactor: l.optional(l.boolean()),
    active: l.optional(l.boolean()),
    status: l.optional(
      l.string<{ knownValues: ['takendown', 'suspended', 'deactivated'] }>(),
    ),
  }),
  ['AccountTakedown', 'AuthFactorTokenRequired'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
